import {getUrlParams, GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {ref} from "vue";
import {PageEnum} from "@/enums/pageEnum";
import {getCurPageType, getCurShowType} from "@/utils/xmCom/curSystemCachUtils";

export function useAppAndTemplate() {
  const runningShow = ref(GoingNewUtils.parseBoolean(StorageUtils.getSessionItem('runningShow') + ''));
  const showType = ref(getCurShowType());
  const appId: any = ref(StorageUtils.getSessionItem("appId")||getUrlParams("appId",true));
  const templateId:any =ref(StorageUtils.getSessionItem("templateId"));
  /**
   * 判断是应用预览或者模版预览
   * @param href
   */
  function judgmentIsAppOrTemp(href) {
    //如果是系统登录访问
    if (href.indexOf('userId=') >= 0) {
      StorageUtils.addSessionItem('runningShow', true);
      runningShow.value = true;
    }
    //如果是应用预览情况下
    if(getCurPageType()===PageEnum.APP_SHOW){
      runningShow.value = false;
      //如果是应用预览
      if (href.indexOf('/appShowByApp') >= 0) {
        StorageUtils.addSessionItem(PageEnum.TEMPLATE_ID, '');
      } else {
        //如果是应用模版预览
        const tempId = getUrlParams(PageEnum.TEMPLATE_ID, true)||StorageUtils.getSessionItem(PageEnum.TEMPLATE_ID);
        if (tempId) {
          templateId.value = tempId;
          appId.value = getUrlParams(PageEnum.APP_ID, true);
          StorageUtils.addSessionItem(PageEnum.TEMPLATE_ID,unref(templateId));
        } else {
          appId.value = getUrlParams(PageEnum.APP_ID, true)||StorageUtils.getSessionItem("appId");
          StorageUtils.removeSessionItem(PageEnum.TEMPLATE_ID);
          templateId.value='';
        }
        StorageUtils.addSessionItem(PageEnum.APP_ID,unref(appId));
      }
    }
    //如果是门户设计
    if (href.indexOf('/analysisSet') >= 0) {
      runningShow.value = false;
      showType.value = 'analysisSet';
    }
    StorageUtils.addSessionItem('runningShow', unref(runningShow));
  }

  return {
    templateId,
    appId,
    runningShow,
    showType,
    judgmentIsAppOrTemp
  }
}
